"use strict";

// returns the size + quotation marks for "inches". (eg. 8x10")
module.exports = function (accumulator, order, product, component) {
  var addition = "".concat(component.size, "\""); // if the component has the product_size field, and it does not equal
  // the true size, add "FOLDED TO <product_size>".

  if (component.product_size && component.size !== component.product_size.replace('_', '.')) {
    addition = "".concat(component.size, "\" - FOLDED TO ").concat(component.product_size);
  }

  if (accumulator.length) {
    return accumulator + ' ' + addition;
  }

  return addition;
};